export function useDateTimeFormatter() {
	const formatters = new Map<string, Intl.DateTimeFormat>();

	function format(anyDt: string | number | Date, timezone: string) {
		const date = new Date(anyDt);

		if (isNaN(date.getTime())) {
			return "";
		}

		let formatter = formatters.get(timezone);
		if (formatter == null) {
			formatter = new Intl.DateTimeFormat("en-CA", {
				timeZone: timezone,
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
				hourCycle: "h23",
			});
			formatters.set(timezone, formatter);
		}

		let year = "",
			month = "",
			day = "",
			hour = "",
			minute = "",
			second = "";

		const parts = formatter.formatToParts(date);
		for (const part of parts) {
			switch (part.type) {
				case "year":
					year = part.value;
					break;

				case "month":
					month = part.value;
					break;

				case "day":
					day = part.value;
					break;

				case "hour":
					hour = part.value;
					break;

				case "minute":
					minute = part.value;
					break;

				case "second":
					second = part.value;
					break;
			}
		}

		return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
	}

	return format;
}
